<template lang="pug">
  payout-form-group(:label="activeLabel" :required='model.isRequiredAttribute(attribute)' :has-errors='model.errors.hasErrorsSplit(errorsAttribute)')
    template(v-if="modelHasFeeRule" v-slot:labelinner)
      | {{$t('Комиссия')}}
      |
      |
      br
      small ({{modelFeeRule.base}}%
        template(v-if="modelFeeRuleFix")
          | ,
          |
          |
          | fix. {{modelFeeRuleFix.amount|money(modelFeeRuleFix.currency)}} {{modelFeeRuleFix.currency}}
        template(v-if="modelFeeRuleMin")
          | ,
          |
          |
          | min. {{modelFeeRuleMin.amount|money(modelFeeRuleMin.currency)}} {{modelFeeRuleMin.currency}}
        | )

    payout-evaluate-fee-block(:model="model" @amount-dirty="onDirty" @tax="onTax" @taxfail="onTaxFail" :link-text="$t('Рассчитать')" :evaluating-text="$t('Рассчитывается...')")

</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PayoutFormGroup from '@/components/forms/payout/PayoutFormGroup.vue';
import InputAmount from '@/components/forms/payout/legacy/InputAmount.vue';
import PayoutInputHintBlock from '@/components/forms/payout/PayoutInputHintBlock.vue';
import ErrorMessageBlock from '@/components/forms/payout/ErrorMessageBlock.vue';
import {
  EvaluateReverseFeeResultInterface,
  PayoutTaxRuleInterface,

} from '@/components/forms/payout/payout-basics';
import PayoutEvaluateFeeBlock from '@/components/forms/payout/PayoutEvaluateFeeBlock.vue';
import { CurrencyCode } from '@/models/core/currency';
import { MoneyFormatFilter } from '@/models/filters/money';
import { MoneyAmount } from '@/models/finance/money';
import {PayoutWebModel} from "capitalist-shared/src/finance/payments";
import {scrollToFirstError} from "@/views/pages/finance/payout/payout.legacy";
import { nextTick } from 'vue';

// const localScrollTo = (selector: string) => {
//   scrollTo(selector, {
//     nextTick: nextTick
//   });
// }


@Component({
  name: 'payout-evaluate-fee-form-group',
  components: {
    PayoutEvaluateFeeBlock, ErrorMessageBlock, PayoutInputHintBlock, InputAmount, PayoutFormGroup,
  },
  filters: {
    money: MoneyFormatFilter,
  },
})
export default class PayoutEvaluateFeeFormGroup extends Vue {
  @Prop({ default: null })
  model!: PayoutWebModel

  @Prop({ default: 'amount' })
  attribute!: string

  @Prop({ default: 'amount' })
  errorsAttribute!: string

  @Prop({ default: false })
  disabled!: boolean

  reverseFeeRequest = {
    id: 0,
    dirty: true,
    account: null,
  }

  currentTax = null
  currentTaxDirty = false

  get isNegativeCommission() {
    return !this.currentTaxDirty && (this.currentTax !== null) && (this.currentTax.feeAmount < 0)
  }

  get activeLabel() {
    return this.$t(this.isNegativeCommission ? 'Кешбэк' : 'Комиссия')
  }

  onDirty() {
    this.currentTaxDirty = true
    this.currentTax = null
  }

  onTax(tax) {
    this.currentTax = tax
    this.currentTaxDirty = false
  }

  onTaxFail() {
    this.currentTax = null
    this.currentTaxDirty = false
    scrollToFirstError({nextTick: nextTick})
  }

  get modelFeeRule(): PayoutTaxRuleInterface | null {
    return ('taxRule' in this.model.options)
    && this.model.options.taxRule ? this.model.options.taxRule as PayoutTaxRuleInterface : null;
  }

  get modelFeeRuleFix(): MoneyAmount | null {
    if (!this.modelFeeRule) return null
    const preferredCurrency = CurrencyCode.RUR;
    for (const fix of this.modelFeeRule.fix) {
      if (fix.currency === preferredCurrency) return fix;
    }

    if (this.modelFeeRule.fix.length > 0) return this.modelFeeRule.fix[0];
    return null;
  }

  get modelFeeRuleMin(): MoneyAmount | null {
    if (!this.modelFeeRule) return null
    return (Number(this.modelFeeRule.min.amount) > 0)
    && (this.modelFeeRule.min.currency) ? this.modelFeeRule.min : null;
  }

  get modelHasFeeRule(): boolean {
    return Boolean(this.modelFeeRule);
  }

  updateValue(value: any) {
    this.$emit('input', value);
    this.model.values.amount = value;
  }

  onAvailBalanceClick($event?: any) {
    this.evaluateReverseFee();
  }

  evaluateReverseFee() {
    if (this.reverseFeeRequest.account
        && (this.reverseFeeRequest.account == this.model.values.fromAccount)) return;

    const requestId = ++this.reverseFeeRequest.id;

    this.reverseFeeRequest.account = this.model.values.fromAccount;
    this.model.errors.clear();

    this.updateValue('');

    this.model.evaluateReverseFee().then((result: EvaluateReverseFeeResultInterface) => {
      if (this.reverseFeeRequest.account == this.model.values.fromAccount) {
        if (requestId == this.reverseFeeRequest.id) {
          this.reverseFeeRequest.account = null;
          this.updateValue(result.amount);
        }
      }
    }, /* , (result?: any) => {
      if (this.reverseFeeRequest.account == this.model.values.fromAccount)
        if (requestId == this.reverseFeeRequest.id) {
          this.reverseFeeRequest.account = null;
          if (result && result.model.hasErrors) {
            this.model.errors.setErrors(result.model.errors, result.model.syserrors);
          }
        }
    } */);
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "Всего": "Total",
    "Комиссия": "Commission",
    "Кешбэк": "Cashback",
    "Рассчитать": "Calculate",
    "Рассчитывается...": "Calculating..."
  }
}
</i18n>
